import {BOOK_CREATED} from "../types";
import {EDIT_META_DATA} from "../types";
export default function booksCUD(state = {}, action = {}) {
    switch (action.type) {
        case BOOK_CREATED:
            return action.data;
        case EDIT_META_DATA:
            return action.data;
        default:
            return state
    }
}